import React from "react";
import { string, bool, func } from "prop-types";

import * as i18n from "util/i18n";
// import I18n from "pages/_components/I18n";
import Drawer from "pages/_components/Drawer/Drawer";
const MasInformacion = ({ page, slideIsVisible, closeSlide }) => {
    

    return (
        <Drawer className="help-slider" openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
            <div className="container">
                <div className="row" dangerouslySetInnerHTML={{
                                __html: i18n.get("loans.common.moreInformation.content"),
                            }}>
                    
                </div>
            </div>
        </Drawer>
    );
};

MasInformacion.propTypes = {
    page: string.isRequired,
    slideIsVisible: bool.isRequired,
    closeSlide: func.isRequired,
};

export default MasInformacion;
